import { Checkbox } from '@/components/ui/checkbox'
import { FilterSection } from './FilterSection'
import { Star } from 'lucide-react'

interface FilterSectionFavoritedProps {
  value: boolean | undefined
  onChange: (value: boolean | undefined) => void
}

export function FilterSectionFavorited({ value, onChange }: FilterSectionFavoritedProps) {
  return (
    <FilterSection icon={Star} label="Favoritos">
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="favorited-only"
            checked={value === true}
            onCheckedChange={(checked) => onChange(checked ? true : undefined)}
          />
          <label htmlFor="favorited-only" className="text-sm cursor-pointer">
            Apenas Favoritos
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="favorited-not"
            checked={value === false}
            onCheckedChange={(checked) => onChange(checked ? false : undefined)}
          />
          <label htmlFor="favorited-not" className="text-sm cursor-pointer">
            Não Favoritos
          </label>
        </div>
      </div>
    </FilterSection>
  )
}
